<template>
  <div>
    <!-- Filter CB Modal Start -->
    <b-button
      style="font-size: 0.675rem ;margin-left: 5px;margin-bottom:4px;"
      @click="FilterClinet()"
      size="sm"
      variant="warning"
      class="ml-1 mr-1"
      >Client Search</b-button
    >
    <b-modal
      id="FilterClinet-modal"
      ref="FilterClinet-modal"
      title="Filter Client"
      size="xl"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <div class="row">
        <div class="col-md-8">
          <b-form-input
            class="mb-2 w-100"
            :formatter="capitalizeAll"
            v-model="filterClientName"
            v-on:keyup="ClientFilterFunct(true)"
            placeholder="Type to Search"
          />
        </div>
        <div class="col-md-4">
          <b-button @click="ClientFilterFunct(false)">Clear</b-button>
          <strong>{{ getClientNameDocList.length }} Entries</strong>
        </div>
        <div class="col-md-12">
          <h1>{{ DataSearch }}</h1>
          <CustomLoader v-if="isLoading" :width="70"></CustomLoader>

          <!-- :class="{ 'fade-in': fadeIn }" -->
          <div class="card" v-if="getClientNameList.clientName">
            <div class="card-header">
              <a :href="DataSearch" target="_blank">{{ getClientNameList.clientName }}</a>
            </div>
            <div class="card-body">
              <div class="client-details">
                <b-row>
                  <!-- {{getClientNameList}} -->
                  <b-col md="4"
                    ><p>
                      <strong>Type : </strong>{{ getClientNameList.clientType }}
                    </p></b-col
                  >
                  <b-col md="4"
                    ><p>
                      <strong>Name : </strong>{{ getClientNameList.clientName }}
                    </p></b-col
                  >
                  <b-col md="4"
                    ><p><strong>Email : </strong>{{ getClientNameList.email }}</p></b-col
                  >
                  <b-col md="4"
                    ><p>
                      <strong>Contact No : </strong>{{ getClientNameList.phoneKYC }}
                    </p></b-col
                  >
                  <b-col md="4"
                    ><p>
                      <strong>Alternate Email : </strong>{{ getClientNameList.altMail }}
                    </p></b-col
                  >
                  <b-col md="4"
                    ><p>
                      <strong>PAN No. : </strong>{{ getClientNameList.panNO }}
                    </p></b-col
                  >
                  <b-col md="4"
                    ><p>
                      <strong>IEC Number : </strong>{{ getClientNameList.IEC }}
                    </p></b-col
                  >
                  <b-col md="4"
                    ><p>
                      <strong>Type of Company : </strong
                      >{{ getClientNameList.companyType }}
                    </p></b-col
                  >
                  <b-col md="4"
                    ><p>
                      <strong>State : </strong>{{ getClientNameList.stateName }}
                    </p></b-col
                  >
                  <b-col md="4"
                    ><p>
                      <strong>Company Permitted : </strong
                      >{{ getClientNameList.permitted }}
                    </p></b-col
                  >
                  <b-col md="4"
                    ><p><strong>TAN No : </strong>{{ getClientNameList.tanNO }}</p></b-col
                  >
                  <b-col md="4"
                    ><p><strong>GSTN Code : </strong>{{ getClientNameList.gstCode }}</p></b-col
                  >
                  <b-col md="4"
                    ><p><strong>GSTN No : </strong>{{ getClientNameList.gstCode+getClientNameList.GSTN }}</p></b-col
                  >
                  <b-col md="4"
                    ><p>
                      <strong>Corporate Address : </strong
                      >{{ getClientNameList.corporateAddress }}
                    </p></b-col
                  >
                  <b-col md="4"
                    ><p>
                      <strong>Credit Days : </strong>{{ getClientNameList.creditDays }}
                    </p></b-col
                  >
                  <b-col md="4"
                    ><p>
                      <strong>Remarks : </strong
                      >{{ getClientNameList.remarkOtherDocument }}
                    </p></b-col
                  >
                  <b-col md="4">
                  <b-button
                    style="font-size: 0.675rem"
                    size="sm"
                    variant="primary"
                    @click="downloadZip(getClientNameList)"
                    >Download Zip</b-button></b-col>
                </b-row>

                <!-- Add more client details as needed -->
              </div>
            </div>
          </div>
          <b-table
            v-if="getClientNameDocList.length > 0"
            show-empty
            stacked="md"
            :items="getClientNameDocList"
            :fields="fields"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
          >
            <template slot="SN" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="kycDocName" slot-scope="row1">
              <span v-if="row1.item.kycDocName">
                {{ row1.item.kycDocName }}
              </span>
            </template>
            <template slot="uploadedkycDoc" slot-scope="row2">
              <a
                class="showMoreData"
                :href="
                  `${docURL}/` +
                  `${
                    row2.item.uploadedkycDoc.includes('CLIENTKYCDOC')
                      ? ''
                      : 'CLIENTKYCDOC/'
                  }` +
                  row2.item.uploadedkycDoc
                "
                v-if="row2.item.uploadedkycDoc != ''"
                target="_blank"
                download
                ><u>View Document -{{ row2.index + 1 }}</u></a
              >
              <!-- <a
                @click="
                  previewPrivateDocs(
                    `${
                      row2.item.uploadedkycDoc.includes('CLIENTKYCDOC')
                        ? row2.item.uploadedkycDoc.replace('CLIENTKYCDOC/', '').trim()
                        : row2.item.uploadedkycDoc
                    }`
                  )
                "
                class="showMoreData"
                v-if="row2.item.uploadedkycDoc != ''"
                target="_blank"
                download
                ><u>View - {{ row2.index + 1 }}</u></a
              > -->
            </template>
          </b-table>
        </div>
      </div>
      <b-button @click="hideFilterClinet" variant="danger" class="pull-right mt-2">
        Close</b-button
      >
    </b-modal>
    <!-- Filter CB Modal End -->
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import CommonService from "../../services/CommonService.js";
import NodeLockPannelService from "../../services/NodeLockPannelService.js";
export default {
  props: {
    document: Object,
    client: Object,
  },
  data() {
    return {
      isLoading:false,
      docURL: URL_BASE_DOC,
      fadeIn: false,
      CBList: [],
      filterClientName: "",
      totalRows: 0,
      currentPage: 1,
      perPage: 25,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      fields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "kycDocName",
          mainkey: "kycDocName",
          label: "Document Name",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "uploadedkycDoc",
          mainkey: "uploadedkycDoc",
          label: "Action",
          sortable: true,
          sortDirection: "ASC",
          table: "K.",
        },
      ],
      DataSearch: "",
      getClientNameList: {},
      getClientNameDocList: [],
      clientName: "",
    };
  },
  components: {
    CustomLoader,
  },
  mounted() {
    // Set fadeIn to true after the component is mounted to trigger the animation
    this.fadeIn = true;
  },
  methods: {
    downloadZip(items) {
      NodeLockPannelService.downloadClientZip(items.clientId)
        .then((response) => {
            const { data, status } = response;

            if (status === 200 && data) {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `${items.clientName}_${items.clientId}_docs.zip`); // Set a default file name
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url); // Clean up
            }
        })
        .catch((error) => {
            console.log("Catch on downloadZip Error: ", error);
        });
    },
    FilterClinet() {
      this.filterClientName = "";
      this.$refs["FilterClinet-modal"].show();
    },
    hideFilterClinet() {
      this.filterClientName = "";
      this.$refs["FilterClinet-modal"].hide();
    },
    ClientFilterFunct(status) {
      this.getClientNameList = {};
      this.getClientNameDocList = [];
      if (status == true) {
        this.getClientDetails(status);
        this.isLoading = true;
        if (this.filterClientName.length === 0) {
          this.isLoading = false;
        }
      } else {
        this.isLoading = false;
        this.filterClientName = "";
        this.getClientNameList = {};
      }
    },
    previewPrivateDocs(item) {
      let paylod = {
        privateDocName: item,
        id: "Client_Kyc",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/viewPrivateDoc.php`,
        data: JSON.stringify(paylod),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options).then((result) => {
        const { statusText, status, data } = result;
        if (status == 200 && data) {
          if (data.status == "success") {
            window.open(`${this.docURL}/CLIENTKYCDOC/` + item);
          } else {
            this.alert.content = "Document Not Found";
            this.$refs["PopDoc"].open();
          }
        }
      });
    },
    getClientDetails(status) {
      //   this.isLoading = true;
      this.DataSearch = "";
      this.getClientNameList = {};
      this.getClientNameDocList = [];
      if (
        this.filterClientName != "" &&
        this.filterClientName != undefined &&
        this.filterClientName != null
      ) {
        let payload = {
          itemCode: "getClientNameList",
          filterClientName: this.filterClientName,
        };

        CommonService.getAllJobList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            console.log();
            if (status == 200 && data.getClientNameFLAG == 1) {
              this.isLoading = false;
              this.getClientNameList = data.getClientNameList;
              if (
                data.getClientNameList.uploadedkycDoc != null &&
                data.getClientNameList.uploadedkycDoc != ""
              ) {
                let uploadedDoc = data.getClientNameList.uploadedkycDoc.split(",");
                let uploadedDocName = data.getClientNameList.kycDocName.split(",");
                console.log("this.getClientNameList: ", uploadedDoc);
                for (let i = 0; i < uploadedDoc.length; i++) {
                  let obj = {
                    kycDocName: uploadedDocName[i],
                    uploadedkycDoc: uploadedDoc[i],
                  };
                  this.getClientNameDocList.push(obj);
                  this.fadeIn = true;
                }
              }
            }
          })
          .catch((error) => {
            console.log("Catch on getClientNameList Error: ", error);
          });
      }
    },
  },
};
</script>
<style scoped>
.card {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin: 10px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, opacity 0.5s ease;
}

.card:hover {
  transform: scale(1.05);
}

.card-header {
  background-color: #3498db;
  color: #b90f0f;
  padding: 10px;
  font-weight: bold;
}

.card-body {
  padding: 15px;
}

.client-details {
  margin-top: 10px;
  color: #555555;
}

a {
  color: #3498db;
  text-decoration: none;
  font-weight: bold;
}

a:hover {
  text-decoration: underline;
}

/* Fade-in Animation */
.fade-in {
  opacity: 0;
}

.fade-in-enter-active {
  transition: opacity 0.5s;
}

.fade-in-enter-to {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// clientCard.vue?e1ea34a8